(function() {
    'use strict';

    angular.module('user')
        .controller('AdminUpdateController', AdminUpdateController);

    AdminUpdateController.$inject = [
        '$state',
        'adminDataSrvc',
        'notificationSrvc',
        'adminMessagesConst',
        'competenceDataSrvc',
        'modelPermissionsGroupDataSrvc',
        'machineDataSrvc',
        'machineActionsDataSrvc',
        'errorNotificationSrvc',
        'userStorageSrvc'
    ];

    function AdminUpdateController(
        $state, adminDataSrvc, notificationSrvc, adminMessagesConst, competenceDataSrvc, modelPermissionsGroupDataSrvc,
        machineDataSrvc, machineActionsDataSrvc, errorNotificationSrvc, userStorageSrvc
    ) {
        var self = this;
        self.loggedUser = userStorageSrvc.getUser();

        self.serverErrors = {
            user: {
                username: [],
                password: [],
                email: [],
                first_name: [],
                last_name: [],
                user_permissions: [],
                groups: [],
                site_permissions: [],
            },
            competencies: [],
            machine_actions: [],
            nonFieldErrors: []
        };
        self.adminData = {};
        self.groupList = [];
        self.competencies = [];
        self.machineActions = [];

        self.updateAdmin = updateAdmin;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getAdmin();
            getCompetencies();
            getGroupList();
            getMachines();
        }

        function getAdmin() {
            return adminDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(
                function(response) {
                    self.adminData = response;
                }
            );
        }

        function getCompetencies() {
            return competenceDataSrvc.adminList().$promise.then(
                function(response) {
                    self.competencies = response;
                    return response;
                }
            );
        }

        function getMachines() {
            return machineActionsDataSrvc.adminList().$promise.then(
                function(response) {
                    self.machineActions = response;
                    return response;
                }
            );
        }


        function getGroupList() {
            return modelPermissionsGroupDataSrvc.adminList()
                .$promise.then(
                    function(response) {
                        self.groupList = response;
                        return response;
                    }
                );
        }

        function updateAdmin() {
            if (typeof self.adminData.image === 'string'){
                delete self.adminData.image;
            }

            adminDataSrvc.update({
                pk: self.adminData.pk
            }, self.adminData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", adminMessagesConst.update);
                    $state.go('layout.admin.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(errorField, key) {
            if (errorField !== undefined) {
                errorField[key] = [];
            }
        }
    }
})();
